import React, { useEffect, useState, useCallback, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Shower } from "@mui/icons-material";
import axiosRequest from "../../api/axios";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import { CropLandscapeOutlined } from "@material-ui/icons";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadImg from "../../assests/download.svg";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { height } from "@mui/system";
import { CSVLink } from "react-csv";
import MaterialReactTable from "material-react-table";
import LoadingButton from "@mui/lab/LoadingButton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachmentIcon from "@mui/icons-material/Attachment";

export default function RBMTable() {
  const [budget, setBudget] = useState(0);
  const [budgetId, setBudgetId] = useState(0);
  const [temp, settemp] = useState(0);
  const [rows, setrows] = useState([]);
  const [isdatapresent, setIsDataPresent] = useState(false);
  const csv_year = String(localStorage.getItem("year") - 1).slice(-2);

  function sumArray(array) {
    let sum = 0;

    /*Go through each item in the array and execute this function which adds
  each item to sum 
  */
    array.forEach((item) => {
      sum += parseInt(item);
    });

    // console.log(sum, "SUMMM");
    return sum;
  }

  // logic for increase/decrease_1
  const [loader, setLoader] = useState(false);
  const [unadjustedList, setunadjustedList] = useState({});
  const [addedList, setaddedList] = useState({});
  const [showErrorMsg, setshowErrorMsg] = useState(false);
  const [adjustedBrand, setadjustedBrand] = useState("");
  const [adjustedId, setadjustedId] = useState(0);
  const [errorMessage, seterrorMessage] = useState("");
  const [EnteredValue, setEnteredValue] = useState(0);
  const [brandWiseSum, setbrandWiseSum] = useState(0);
  const [totalBrandSum, settotalBrandSum] = useState({});
  const [adjustedtotalBrandSum, setadjustedTotalBrandSum] =
    useState(totalBrandSum);
  const [keysList, setkeysList] = useState([]);
  const [calculatedRci, setcalculatedRci] = useState("");
  const [comments, setcomments] = useState("");
  const [commentsColor, setcommentsColor] = useState("");
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };
  const handleClose = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  // Api to get Total table data
  const gettabledata = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getbuheaddata/",
      method: "POST",
      headers: api_headers,
      data: {
        team: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        setunadjustedList(data?.data?.m1unadj);
        setunadjustedList1(data?.data?.m2unadj);
        setunadjustedList2(data?.data?.m3unadj);
        setaddedList(data?.data?.m1unadj);
        setaddedList1(data?.data?.m2unadj);
        setaddedList2(data?.data?.m3unadj);
        settotalBrandSum(data?.data?.totm1unadj);
        settotalBrandSum1(data?.data?.totm2unadj);
        settotalBrandSum2(data?.data?.totm3unadj);
        handleSnackBar("Data Loaded Successfully", "success");

        // setReasonSelected(false);
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        setchangesSaved(false);

        handleSnackBar("No Data Found", "error");
      }
    });
  };

  // API to get filters data

  const [filtersData, setfiltersData] = React.useState({});
  const [BrandsListData, setBrandsListData] = React.useState([]);
  const [productsListData, setproductsListData] = React.useState([]);
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [selectedProduct, setselectedProduct] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});

  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/getfiltersdata",
      method: "POST",
      headers: api_headers,
      data: {
        team: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = [];

        setfiltersData(data?.data?.data);

        for (let brand of data?.data?.data) {
          temp_list.push(brand["brandname"]);
        }
        setBrandsListData(temp_list);

        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
      }
    });
  };

  //Api to filter the metrics selected on the brand and product filter
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");

  const [AllBrandStatus, setAllBrandStatus] = React.useState([]);
  const [proceedSubmit, setproceedSubmit] = React.useState(false);

  const getAllBrandsStatus = async () => {
    await axiosRequest({
      url: "bu_head_app/filtersresult",
      method: "POST",
      headers: api_headers,
      data: {
        brandname: "All",
        productname: ["All"],
        teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setAllBrandStatus(data?.data?.data);
        setQuarter(data?.data?.data[0]["quarter"]);
        setIsDataPresent(true)
        handleSnackBar("Data Loaded Successfully!", "success");
        for (let item of AllBrandStatus) {
          if (item["status"] === "approved by commercialhead") {
            setdisabled(true);
          } else {
            setdisabled(false);
          }
        }
      } else if(data.msg==="No data found"){
        setrows([])
        setIsDataPresent(false)
        handleSnackBar("No data found ", "error");
      }else {
        setIsDataPresent(false)
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };

  // Modal  Variables for Overview Modal
  const [UnadjustedMonth1Total, setUnadjustedMonth1Total] = useState(0);
  const [UnadjustedMonth2Total, setUnadjustedMonth2Total] = useState(0);
  const [UnadjustedMonth3Total, setUnadjustedMonth3Total] = useState(0);
  const [AdjustedMonth1Total, setAdjustedMonth1Total] = useState(0);
  const [AdjustedMonth2Total, setAdjustedMonth2Total] = useState(0);
  const [AdjustedMonth3Total, setAdjustedMonth3Total] = useState(0);
  const [showOverviewModal, setshowOverviewModal] = useState(false);
  const [filtersDataSum, setfiltersDataSum] = React.useState({});
  let sum_data = {
    unadj_tot: 0,
    unadj1_tot: 0,
    unadj2_tot: 0,
    adj_tot: 0,
    adj1_tot: 0,
    adj2_tot: 0,
    gr_tot: 0,
    gr_tot1: 0,
    gr_tot2: 0,
    gr_tot_unadj: 0,
    gr_tot_unadj1: 0,
    gr_tot_unadj2: 0,
    unadj_tot_un: 0,
    unadj1_tot_un: 0,
    unadj2_tot_un: 0,
    adj_tot_un: 0,
    adj1_tot_un: 0,
    adj2_tot_un: 0,
  };
  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/filtersresult",
      method: "POST",
      headers: api_headers,
      data: {
        brandname: selectedBrand,
        productname: selectedProduct == "All" ? ["All"] : [selectedProduct],
        teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        setIsDataPresent(true)
        setAllBrandStatus(data?.data?.data);
        handleSnackBar("Data Loaded Successfully", "success");
        
        let tot_data = data?.data?.data;
        let unadj_tot = 0;
        let unadj1_tot = 0;
        let unadj2_tot = 0;
        let unadj_tot_un = 0;
        let unadj1_tot_un = 0;
        let unadj2_tot_un = 0;
        let adj_tot = 0;
        let adj1_tot = 0;
        let adj2_tot = 0;
        let adj_tot_un = 0;
        let adj1_tot_un = 0;
        let adj2_tot_un = 0;
        let gr_tot = 0;
        let gr_tot1 = 0;
        let gr_tot2 = 0;
        let gr_tot_unadj = 0;
        let gr_tot_unadj1 = 0;
        let gr_tot_unadj2 = 0;

        for (let item of AllBrandStatus) {
          if (item["status"] === "approved by commercialhead") {
            setdisabled(true);
          } else {
            setdisabled(false);
          }
        }
        for (let i = 0; i < tot_data?.length; i++) {
          unadj_tot =
            unadj_tot + parseFloat( tot_data[i]["m1_unadjusted_budget_value"] != null ? tot_data[i]["m1_unadjusted_budget_value"] : 0);
          unadj1_tot =
            unadj1_tot + parseFloat(tot_data[i]["m2_unadjusted_budget_value"] != null ? tot_data[i]["m2_unadjusted_budget_value"] : 0);
          unadj2_tot =
            unadj2_tot + parseFloat(tot_data[i]["m3_unadjusted_budget_value"] != null ? tot_data[i]["m3_unadjusted_budget_value"] : 0);
          adj_tot =
            adj_tot + parseFloat( tot_data[i]["m1_adjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0);
          adj1_tot =
            adj1_tot + parseFloat(tot_data[i]["m2_adjusted_budget_value"] != null ? tot_data[i]["m2_adjusted_budget_value"] : 0);
          adj2_tot =
            adj2_tot + parseFloat( tot_data[i]["m3_adjusted_budget_value"] != null ? tot_data[i]["m3_adjusted_budget_value"] : 0);
          unadj_tot_un =
            unadj_tot_un + parseFloat(tot_data[i]["m1_unadjusted_budget_unit"] != null ? tot_data[i]["m1_unadjusted_budget_unit"] : 0);
          unadj1_tot_un =
            unadj1_tot_un +
            parseFloat(tot_data[i]["m2_unadjusted_budget_unit"] != null ? tot_data[i]["m2_unadjusted_budget_unit"] : 0);
          unadj2_tot_un =
            unadj2_tot_un +
            parseFloat(tot_data[i]["m3_unadjusted_budget_unit"] != null ? tot_data[i]["m3_unadjusted_budget_unit"] : 0);
          adj_tot_un =
            adj_tot_un + parseFloat( tot_data[i]["m1_adjusted_budget_unit"] != null ? tot_data[i]["m1_adjusted_budget_unit"] : 0);
          adj1_tot_un =
            adj1_tot_un + parseFloat(tot_data[i]["m2_adjusted_budget_unit"] != null ? tot_data[i]["m2_adjusted_budget_unit"] : 0);
          adj2_tot_un =
            adj2_tot_un + parseFloat(tot_data[i]["m3_adjusted_budget_unit"] != null ? tot_data[i]["m3_adjusted_budget_unit"] : 0);
          // gr_tot =
          //   gr_tot + parseFloat(tot_data[i]["new_defaultvalue1"]);
          // gr_tot1 =
          //   gr_tot1 + parseFloat(tot_data[i]["new_defaultvalue2"]);
          // gr_tot2 =
          //   gr_tot2 + parseFloat(tot_data[i]["new_defaultvalue3"]);
          // gr_tot_unadj =
          //   gr_tot_unadj + parseFloat(tot_data[i]["new_defaultvalueunadj1"]);
          // gr_tot_unadj1 =
          //   gr_tot_unadj1 + parseFloat(tot_data[i]["new_defaultvalueunadj2"]);
          // gr_tot_unadj2 =
          //   gr_tot_unadj2 + parseFloat(tot_data[i]["new_defaultvalueunadj3"]);
          // m2_qty_sum = m2_qty_sum+ parseFloat(tot_data[i]["m2_qty"])
          // m2_value_sum = m2_value_sum + parseFloat(tot_data[i]["m2_value"])
          // m2_nsp_sum = m2_nsp_sum + parseFloat(tot_data[i]["m2_nsp"])
          // m3_qty_sum = m3_qty_sum+ parseFloat(tot_data[i]["m3_qty"])
          // m3_value_sum = m3_value_sum + parseFloat(tot_data[i]["m3_value"])
          // m3_nsp_sum = m3_nsp_sum + parseFloat(tot_data[i]["m3_nsp"])
        }
        sum_data["unadj_tot"] = parseFloat(unadj_tot).toFixed(8);
        sum_data["unadj1_tot"] = parseFloat(unadj1_tot).toFixed(8);
        sum_data["unadj2_tot"] = parseFloat(unadj2_tot).toFixed(8);
        sum_data["adj_tot"] = parseFloat(adj_tot).toFixed(8);
        sum_data["adj1_tot"] = parseFloat(adj1_tot).toFixed(8);
        sum_data["adj2_tot"] = parseFloat(adj2_tot).toFixed(8);
        sum_data["unadj_tot_un"] = parseFloat(unadj_tot_un).toFixed(8);
        sum_data["unadj1_tot_un"] = parseFloat(unadj1_tot_un).toFixed(8);
        sum_data["unadj2_tot_un"] = parseFloat(unadj2_tot_un).toFixed(8);
        sum_data["adj_tot_un"] = parseFloat(adj_tot_un).toFixed(8);
        sum_data["adj1_tot_un"] = parseFloat(adj1_tot_un).toFixed(8);
        sum_data["adj2_tot_un"] = parseFloat(adj2_tot_un).toFixed(8);
        sum_data["gr_tot"] = parseFloat(data?.data?.growthval1).toFixed(8);
        sum_data["gr_tot1"] = parseFloat(data?.data?.growthval2).toFixed(8);
        sum_data["gr_tot2"] = parseFloat(data?.data?.growthval3).toFixed(8);
        sum_data["gr_tot_unadj"] = parseFloat(data?.data?.growthvalun1).toFixed(
          2
        );
        sum_data["gr_tot_unadj1"] = parseFloat(
          data?.data?.growthvalun2
        ).toFixed(8);
        sum_data["gr_tot_unadj2"] = parseFloat(
          data?.data?.growthvalun3
        ).toFixed(8);
        setfiltersDataSum(sum_data);
        // setUnadjustedMonth1Total(data?.data?.totm1unadjval);
        // setAdjustedMonth1Total(data?.data?.totm1adjval);
        // setUnadjustedMonth2Total(data?.data?.totm2unadjval);
        // setAdjustedMonth2Total(data?.data?.totm2adjval);
        // setUnadjustedMonth3Total(data?.data?.totm3unadjval);
        // setAdjustedMonth3Total(data?.data?.totm3adjval);

        setunadjustedList(data?.data?.m1unadj);
        setunadjustedList1(data?.data?.m2unadj);
        setunadjustedList2(data?.data?.m3unadj);
        setaddedList(data?.data?.m1adj);
        setaddedList1(data?.data?.m2adj);
        setaddedList2(data?.data?.m3adj);
        settotalBrandSum(data?.data?.totm1unadj);
        settotalBrandSum1(data?.data?.totm2unadj);
        settotalBrandSum2(data?.data?.totm3unadj);

        //logic to display month name based on Quarter
        if (localStorage.getItem("quarter") == "Q1") {
          setMonth1("Jan");
          setMonth2("Feb");
          setMonth3("Mar");
        } else if (localStorage.getItem("quarter") == "Q2") {
          setMonth1("Apr");
          setMonth2("May");
          setMonth3("Jun");
        } else if (localStorage.getItem("quarter") == "Q3") {
          setMonth1("Jul");
          setMonth2("Aug");
          setMonth3("Sep");
        } else if (localStorage.getItem("quarter") == "Q4") {
          setMonth1("Oct");
          setMonth2("Nov");
          setMonth3("Dec");
        }
        // setfiltersOutputData()
      } else if(data.msg==="No data found"){
        setrows([])
        setIsDataPresent(false)
        setLoader(false);
        handleSnackBar("No data found ", "error");
      }else {
        setIsDataPresent(false)
        setLoader(false);
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };
  React.useEffect(() => {
    localStorage.setItem("adj1sum", JSON.stringify(0));
    getfiltersdata();
    getReasonsdata();
    // getAllBrandsStatus();
    // gettabledata();
  }, []);


  function between(x, min, max) {
    return x >= min && x <= max;
  }
  const [changesSaved, setchangesSaved] = useState(false);
  const [loaderSave, setloaderSave] = useState(false);
  const [loaderSubmit, setloaderSubmit] = useState(false);
  const [tempReasonSelected, settempReasonSelected] = useState(true);
  const [valuesList, setvaluesList] = useState([]);

  const handleSave = async () => {
    if (errorMessage != "" || errorMessage1 != "" || errorMessage2 != "") {
      handleSnackBar(
        "You cannot save until the adjustments are correct please check!",
        "error"
      );
    } else {
      setloaderSave(true);
      await axiosRequest({
        url: "bu_head_app/updatebuheaddata/",
        method: "POST",
        headers: api_headers,
        data: {
          data: rows,
          teamcode: localStorage.getItem("teamcode"),
          year:localStorage.getItem("year"),
          quarter:localStorage.getItem("quarter"),

        },
      }).then((data) => {
        if (data.status === 200) {
          handleSnackBar("updated successfully", "success");
          // gettabledata();
          handleApply();
          setchangesSaved(true);
          setloaderSave(false);
          getAllBrandsStatus();
          setshowErrorMsg2("");
          setshowErrorMsg1("");
          setshowErrorMsg("");
          // setshowErrorMsg3("")
          // Object.entries(AllEditedIdsDict).forEach(([key, value]) => {
          //   if (AllEditedIdsDict[key] === false) {
          //     AllEditedIdsDict[key] = true;
          //   }
          // });
        } else if (data.msg === "adjust negative budgets"){
          handleSnackBar("Adjust Negative budgets before saving for all products", "error");
          setloaderSave(false);
        }else {
          handleSnackBar("data not updated", "error");
          setloaderSave(false);
        }
      });
    }
  };

  //APi for submit
  const [showModal, setshowModal] = useState(false);
  const [showStatusModal, setshowStatusModal] = useState(false);
  const handleCloseModal = () => {
    setshowModal(false);
  };
  const handleCloseStatusModal = () => {
    setshowStatusModal(false);
  };

  const handleCloseOverviewModal = () => {
    setshowOverviewModal(false);
    setEnteredValue(0);
  };

  const handleOverviewModal = () => {
    setshowOverviewModal(true);
    // var unadjusted_var1 = 0
    // var adjusted_var1 = 0
    // for(let item of rows){
    //   unadjusted_var1 = parseFloat(unadjusted_var1) +  parseFloat(item['m1_unadjusted_budget_value'])
    //   // setUnadjustedMonth1Total(parseFloat(UnadjustedMonth1Total) + item['m1_unadjusted_budget_value'])
    //   // UnadjustedMonth1Total = UnadjustedMonth1Total + item['m1_unadjusted_budget_value']
    // }
    // setUnadjustedMonth1Total(unadjusted_var1)
    // const tempunadj1=parseFloat(UnadjustedMonth1Total).toFixed(8);
    // setUnadjustedMonth1Total(tempunadj1)
    // var unadjusted_var2 = 0
    // var adjusted_var2 = 0
    // for(let item of rows){
    //   unadjusted_var2 = parseFloat(unadjusted_var2) +  parseFloat(item['m2_unadjusted_budget_value'])
    // setUnadjustedMonth2Total(parseFloat(UnadjustedMonth2Total) + item['m2_unadjusted_budget_value'])
    // UnadjustedMonth2Total = UnadjustedMonth2Total + item['m2_unadjusted_budget_value']
    // }
    // setUnadjustedMonth2Total(unadjusted_var2)
    // const tempunadj2=parseFloat(UnadjustedMonth2Total).toFixed(8);
    // setUnadjustedMonth2Total(tempunadj2)

    // var unadjusted_var3 = 0
    // var adjusted_var3 = 0
    // for(let item of rows){
    //   unadjusted_var3 = parseFloat(unadjusted_var3) +  parseFloat(item['m3_unadjusted_budget_value'])
    //   // setUnadjustedMonth2Total(parseFloat(UnadjustedMonth3Total) + item['m3_unadjusted_budget_value'])
    //   // UnadjustedMonth3Total = UnadjustedMonth3Total + item['m3_unadjusted_budget_value']
    // }
    // setUnadjustedMonth3Total(unadjusted_var3)
    // const tempunadj3=parseFloat(UnadjustedMonth3Total).toFixed(8);
    // setUnadjustedMonth3Total(tempunadj3)

    // for(let item of rows){
    //   adjusted_var1 = parseFloat(adjusted_var1) +  parseFloat(item['m1_adjusted_budget_value'])

    //   // setAdjustedMonth1Total(parseFloat(AdjustedMonth1Total) + item['m1_adjusted_budget_value'])
    //   // AdjustedMonth1Total = AdjustedMonth1Total + item['m1_adjusted_budget_value']
    // }

    // console.log(adjusted_var1,"TOTAL ADJ")
    // console.log(totalEnteredValuesSum,"ENTERED SUM")
    // let final_sum = parseFloat(adjusted_var1)+parseFloat(totalEnteredValuesSum)
    // setAdjustedMonth1Total(parseFloat(adjusted_var1)+parseFloat(totalEnteredValuesSum));
    // setAdjustedMonth1Total(final_sum)
    // console.log(final_sum,'FINAL VALUE')
    // console.log(AdjustedMonth1Total,"STATE VALUE")
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 510,

    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 300,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };

const handleSubmit = async () => {
  let hasMissingReasons = false;

  for (let item of rows) {
    const violatesGuardrail = 
      item.rci_guardrail_check_m1 !== 'within guardrail' ||
      item.rci_guardrail_check_m2 !== 'within guardrail' ||
      item.rci_guardrail_check_m3 !== 'within guardrail';

    const invalidReason = 
      !item.reason || 
      item.reason === 'Select Reason*' || 
      String(item.reason).length < 8;

    if (violatesGuardrail && invalidReason) {
      checkReasonSelected(item.id); // Mark this item for UI feedback
      hasMissingReasons = true;
    }
  }

  if (hasMissingReasons) {
    handleSnackBar("Please select a valid reason for all the adjustments", "warning");
    return;
  }

  let statusList = AllBrandStatus.map(item => item["status"]);
  const showModal = statusList.some(
    status => !status || status === "" || status === "nan"
  );

  setshowStatusModal(showModal);

  if (errorMessage || errorMessage1 || errorMessage2) {
    handleSnackBar(
      "You cannot save until the adjustments are correct, please check!",
      "error"
    );
    return;
  }

  if (!changesSaved) {
    setshowModal(true);
    return;
  }

  setloaderSubmit(true);

  try {
    const response = await axiosRequest({
      url: "bu_head_app/approval",
      method: "POST",
      headers: api_headers,
      data: {
        data: rows,
        email: localStorage.getItem("email"),
        teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    });

    if (response.status === 200) {
      handleSnackBar("Submitted Successfully", "success");
      handleApply();
      getAllBrandsStatus();
      setAllEditedIdsDict({});
    } else {
      handleSnackBar("Something went wrong", "error");
    }
  } catch (error) {
    handleSnackBar("Submission failed", "error");
  } finally {
    setloaderSubmit(false);
  }
};

  let TotalSum = 0;
  const [anyfieldEdited, setanyfieldEdited] = useState(false);
  const [AllEditedIdsDict, setAllEditedIdsDict] = useState({});
  const [totalEnteredValuesSum, settotalEnteredValuesSum] = useState(0);
  const checkReasonSelected = (id) => {
    AllEditedIdsDict[id] = false;
  };

  const handleID1 = (cell, event) => {
    // if (event.target.value != "") {
    //   checkReasonSelected(params.id);
    // }
    cell.cell.row.original.m1_plus_minus = event.target.value;
    // console.log(
    //   event.target.value,
    //   typeof event.target.value,
    //   parseFloat(event.target.value),
    //   parseFloat(JSON.parse(localStorage.getItem("adj1sum"))),
    //   parseFloat(JSON.parse(localStorage.getItem("adj1sum"))),
    //   "ENtered"
    // );
    // console.log(parseFloat(JSON.parse(localStorage.getItem("adj1sum"))), "sum");

    TotalSum =
      parseFloat(JSON.parse(localStorage.getItem("adj1sum"))) +
      parseFloat(event.target.value);

    // console.log(TotalSum, "TOTAL SUM");
    // localStorage.setItem('adj1sum',JSON.stringify(TotalSum))
    settotalEnteredValuesSum(
      parseFloat(totalEnteredValuesSum) + parseFloat(event.target.value)
    );
    // console.log(totalEnteredValuesSum);
    var m1_plus_minus = event.target.value;

    cell.cell.row.original.m1_plus_minus = m1_plus_minus;
    setadjustedId(cell.cell.row.original.id);
    const enteredValue = event.target.value;

    setEnteredValue(event.target.value);
    const val = document.getElementById("EnteredTxt").value;
    // setAdjustedMonth1Total(parseFloat(UnadjustedMonth1Total));
    // if (enteredValue != "") {
    //   setAdjustedMonth1Total(
    //     (
    //       parseInt(UnadjustedMonth1Total) + parseInt(event.target.value)
    //     ).toFixed(8)
    //   );
    // }

    //  setAdjustedMonth1Total(AdjustedMonth1_Total)
    setadjustedBrand(cell.cell.row.original.prodcode);
    addedList[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
      parseFloat(
        unadjustedList[cell.cell.row.original.prodcode][
          cell.cell.row.original.id
        ]
      );
    // console.log(rows, "++++++++++++++");
    // if(rows.id==params.id){
    // setrows(rows.id.m1_plus_minus=m1_plus_minus)
    // }
    if (enteredValue == "") {
      addedList[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        );
      // cell.cell.row.original.new_defaultvalue1 =cell.cell.row.original.new_defaultvalue1
    } else {
      addedList[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        ) + parseFloat(event.target.value);

      // cell.cell.row.original.new_defaultvalue1 =(((( cell.cell.row.original.m1_adjusted_budget_value/ cell.cell.row.original.new_value1)/100000)-1)*100).toFixed(8)
      // console.log(cell.cell.row.original.new_defaultvalue1,"-----")
      // console.log(" ifffff");
    }

    let sum = 0;
    for (let i in addedList[cell.cell.row.original.prodcode]) {
      sum = sum + parseFloat(addedList[cell.cell.row.original.prodcode][i]);
    }
    adjustedtotalBrandSum[cell.cell.row.original.prodcode] = sum;

    let totalAdjustedUnitSum = 0;

    Object.entries(adjustedtotalBrandSum).forEach(([key, value]) => {
      totalAdjustedUnitSum = totalAdjustedUnitSum + adjustedtotalBrandSum[key];
    });

    // console.log(cell.cell.row.original.dynamic_field.slice(0, -1), "DYNAMIC_RCI");
    if (enteredValue != "") {
      const temp_rci =
        (parseFloat(
          unadjustedList[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        ) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum;

      setcalculatedRci((temp_rci * 100).toFixed(8));
    } else {
      const temp_rci =
        parseFloat(
          unadjustedList[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        ) / totalAdjustedUnitSum;

      setcalculatedRci((temp_rci * 100).toFixed(8));
    }
    setshowErrorMsg(true);

    if (
      parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) <
        parseFloat(cell.cell.row.original.rci) ||
      parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) >
        parseFloat(cell.cell.row.original.maxx)
    ) {
      checkReasonSelected(cell.cell.row.original.id);
    }
  };

  const handleComment = (cell, event) => {
    var comment = event.target.value;
    cell.cell.row.original.comment = comment;
  };
  // logic for increase/decrease_2

  const [unadjustedList1, setunadjustedList1] = useState({});
  const [addedList1, setaddedList1] = useState({});
  const [showErrorMsg1, setshowErrorMsg1] = useState(false);
  const [adjustedBrand1, setadjustedBrand1] = useState("");
  const [adjustedId1, setadjustedId1] = useState(0);
  const [errorMessage1, seterrorMessage1] = useState("");
  const [EnteredValue1, setEnteredValue1] = useState(0);
  const [brandWiseSum1, setbrandWiseSum1] = useState(0);
  const [totalBrandSum1, settotalBrandSum1] = useState({});
  const [adjustedtotalBrandSum1, setadjustedTotalBrandSum1] =
    useState(totalBrandSum1);
  const [keysList1, setkeysList1] = useState([]);
  const [calculatedRci1, setcalculatedRci1] = useState("");
  const [comments1, setcomments1] = useState("");
  const [commentsColor1, setcommentsColor1] = useState("");
  const [temp2, setTemp2] = useState("");
  const [loaderUpload, setloaderUpload] = useState(false);

  const handleID2 = (cell, event) => {
    // if (event.target.value != "") {
    //   checkReasonSelected(params.id);
    // }
    cell.cell.row.original.m2_plus_minus = event.target.value;
    setadjustedId1(cell.cell.row.original.id);
    const enteredValue1 = event.target.value;
    setEnteredValue1(event.target.value);

    const val1 = document.getElementById("EnteredTxt1").value;
    setAdjustedMonth2Total(parseFloat(UnadjustedMonth2Total));
    if (enteredValue1 != "") {
      setAdjustedMonth2Total(
        (parseFloat(AdjustedMonth2Total) + parseFloat(val1)).toFixed(8)
      );
    }
    setadjustedBrand1(cell.cell.row.original.prodcode);
    addedList1[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
      parseFloat(
        unadjustedList1[cell.cell.row.original.prodcode][
          cell.cell.row.original.id
        ]
      );

    if (enteredValue1 == "") {
      addedList1[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList1[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        );
      // const temp_val2 =cell.cell.row.original.new_defaultvalue2
      // setTemp2(temp_val2);
      // console.log(temp2,"+++++++++++")
    } else {
      addedList1[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList1[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        ) + parseFloat(event.target.value);

      // const temp_val2=(((( cell.cell.row.original.m2_adjusted_budget_value/ cell.cell.row.original.new_value2)/100000)-1)*100).toFixed(8)
      // setTemp2(temp_val2);
      // console.log(temp2,"+++++++++++")
    }

    let sum1 = 0;
    for (let i in addedList1[cell.cell.row.original.prodcode]) {
      sum1 = sum1 + parseFloat(addedList1[cell.cell.row.original.prodcode][i]);
    }
    adjustedtotalBrandSum1[cell.cell.row.original.prodcode] = sum1;

    let totalAdjustedUnitSum1 = 0;

    Object.entries(adjustedtotalBrandSum1).forEach(([key, value]) => {
      totalAdjustedUnitSum1 =
        totalAdjustedUnitSum1 + adjustedtotalBrandSum1[key];
    });

    if (enteredValue1 != "") {
      const temp_rci1 =
        (parseFloat(unadjustedList1[cell.cell.row.original.prodcode][cell.cell.row.original.id]) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum1;

      setcalculatedRci1((temp_rci1 * 100).toFixed(8));
    } else {
      const temp_rci1 =
        parseFloat(unadjustedList1[cell.cell.row.original.prodcode][cell.cell.row.original.id]) /
        totalAdjustedUnitSum1;

      setcalculatedRci1((temp_rci1 * 100).toFixed(8));
    }

    setshowErrorMsg1(true);
    if (
      parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) <
        parseFloat(cell.cell.row.original.rci) ||
      parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) >
        parseFloat(cell.cell.row.original.maxx)
    ) {
      checkReasonSelected(cell.cell.row.original.id);
    }
  };

  // logic for increase/decrease_3
  const [unadjustedList2, setunadjustedList2] = useState({});
  const [addedList2, setaddedList2] = useState({});
  const [showErrorMsg2, setshowErrorMsg2] = useState(false);
  const [adjustedBrand2, setadjustedBrand2] = useState("");
  const [adjustedId2, setadjustedId2] = useState(0);
  const [errorMessage2, seterrorMessage2] = useState("");
  const [EnteredValue2, setEnteredValue2] = useState(0);
  const [brandWiseSum2, setbrandWiseSum2] = useState(0);
  const [totalBrandSum2, settotalBrandSum2] = useState({});
  const [adjustedtotalBrandSum2, setadjustedTotalBrandSum2] =
    useState(totalBrandSum2);
  const [keysList2, setkeysList2] = useState([]);
  const [calculatedRci2, setcalculatedRci2] = useState("");
  const [comments2, setcomments2] = useState("");
  const [commentsColor2, setcommentsColor2] = useState("");
  const [selectedFileName, setselectedFileName] = React.useState("");
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [file, setFile] = React.useState("");
  
  const rcicolumn =
    localStorage.getItem("teamcode") == "T1"
      ? "%RCI (V)"
      : "%RCI (U)";
  const adjustedrciname3 =
    localStorage.getItem("teamcode") == "T1"
      ? "Adj RCI V(" + String(Month3) + ")"
      : "Adj RCI U(" + String(Month3) + ")";

  const adjustedrciname2 =
    localStorage.getItem("teamcode") == "T1"
      ? "Adj RCI V(" + String(Month2) + ")"
      : "Adj RCI U(" + String(Month2) + ")";

  const adjustedrciname1 =
    localStorage.getItem("teamcode") == "T1"
      ? "Adj RCI V(" + String(Month1) + ")"
      : "Adj RCI U(" + String(Month1) + ")";

  const handleID3 = (cell, event) => {
    // if (event.target.value != "") {
    //   checkReasonSelected(params.id);
    // }
    cell.cell.row.original.m3_plus_minus = event.target.value;
    setadjustedId2(cell.cell.row.original.id);
    const enteredValue2 = event.target.value;
    setEnteredValue2(event.target.value);
    const val2 = document.getElementById("EnteredTxt2").value;
    setAdjustedMonth3Total(parseFloat(UnadjustedMonth3Total));
    if (enteredValue2 != "") {
      setAdjustedMonth3Total(
        (parseFloat(AdjustedMonth3Total) + parseFloat(val2)).toFixed(8)
      );
    }
    setadjustedBrand2(cell.cell.row.original.prodcode);
    addedList2[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
      parseFloat(
        unadjustedList2[cell.cell.row.original.prodcode][
          cell.cell.row.original.id
        ]
      );
    if (enteredValue2 == "") {
      addedList2[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList2[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        );
      // cell.cell.row.original.new_defaultvalue3 = cell.cell.row.original.new_defaultvalue3
    } else {
      addedList2[cell.cell.row.original.prodcode][cell.cell.row.original.id] =
        parseFloat(
          unadjustedList2[cell.cell.row.original.prodcode][
            cell.cell.row.original.id
          ]
        ) + parseFloat(event.target.value);

      // cell.cell.row.original.new_defaultvalue3 =(((( cell.cell.row.original.m3_adjusted_budget_value/ cell.cell.row.original.new_value3)/100000)-1)*100).toFixed(8)
    }

    let sum2 = 0;
    for (let i in addedList2[cell.cell.row.original.prodcode]) {
      sum2 = sum2 + parseFloat(addedList2[cell.cell.row.original.prodcode][i]);
    }

    adjustedtotalBrandSum2[cell.cell.row.original.prodcode] = sum2;

    let totalAdjustedUnitSum2 = 0;

    Object.entries(adjustedtotalBrandSum2).forEach(([key, value]) => {
      totalAdjustedUnitSum2 =
        totalAdjustedUnitSum2 + adjustedtotalBrandSum2[key];
    });

    if (enteredValue2 != "") {
      const temp_rci2 =
        (parseFloat(unadjustedList2[cell.cell.row.original.prodcode][cell.cell.row.original.id]) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum2;

      setcalculatedRci2((temp_rci2 * 100).toFixed(8));
    } else {
      const temp_rci2 =
        parseFloat(unadjustedList2[cell.cell.row.original.prodcode][cell.cell.row.original.id]) /
        totalAdjustedUnitSum2;
      setcalculatedRci2((temp_rci2 * 100).toFixed(8));
    }
    setshowErrorMsg2(true);
    if (
      parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) <
        parseFloat(cell.cell.row.original.rci) ||
      parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) >
        parseFloat(cell.cell.row.original.maxx)
    ) {
      checkReasonSelected(cell.cell.row.original.id);
    }
  };
const handleFileUpload = async (event) => {
  setloaderUpload(true);

  // const file = event.target.files[0];

  //  if (!file) return;
  const formData = new FormData();
  formData.append("teamcode", localStorage.getItem("teamcode"));
  formData.append("file", file);  
  
  //  const formData = new FormData();
  // formData.append("file", file);
  // formData.append("teamcode", localStorage.getItem("teamcode"),); // replace with your actual teamcode state
  // formData.append("rbmcode", localStorage.getItem("rbmcode"));   // replace with your actual rbmcode state
if (file != "") {
  try {
    const res = await axiosRequest({
      method: "POST",
      url: "bu_head_app/update_buh_data_via_excel/", // replace with actual endpoint
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
        "Content-Type": "multipart/form-data",
      },
      data:formData
    });

    if (res.status === 200) {
      setloaderUpload(false);
      setFile("");

      handleSnackBar("Upload successful and validated", "success");
      handleApply(); // reload data or trigger any refresh
    } else {
      setloaderUpload(false);
      setFile("");
      handleSnackBar(res.msg || "Upload failed", "error");
    }
  } catch (err) {
    setFile("");

    setloaderUpload(false);
    const errorMsg = err.response?.msg || "Upload failed";
    handleSnackBar(errorMsg, "error");

   
  }
} else {
  setloaderUpload(false);
  handleSnackBar("Please select a file to upload", "warning");
};
}
  // const formatFunc = (input) =>{
  //   var x=params.row.adjusted_budget_unit_1;
  //   x=x.toString();
  //   var afterPoint = '';
  //   if(x.indexOf('.') > 0)
  //      afterPoint = x.substring(x.indexOf('.'),x.length);
  //   x = Math.floor(x);
  //   x=x.toString();
  //   var lastThree = x.substring(x.length-3);
  //   var otherNumbers = x.substring(0,x.length-3);
  //   if(otherNumbers != '')
  //       lastThree = ',' + lastThree;
  //   var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  // }
  const [selectedReason, setselectedReason] = useState("");
  let ReasonSelected = true;
  const [loaderFilter, setLoaderFilter] = useState(false);

  const [editedDropdownId, seteditedDropdownId] = useState(false);
  const handleSelectReason = (cell, event) => {
    seteditedDropdownId(cell.cell.row.original.id);
    AllEditedIdsDict[cell.cell.row.original.id] = true;

    cell.cell.row.original.reason = event.target.value;
    // console.log(event.target.value, "SELECTED REASON");
    // setselectedReason(event.target.value);
    // if (selectedReason != "") {
    //   setReasonSelected(true);
    // }
  };
  let colums_rbm = [
    { key: "id", label: "ID" },
    {
      key: "rbmcode",
      label: "RBM Code",
    },
    {
      key: "rbmname",
      label: "RBM Name",
    },
    {
      key: "brand",
      label: "Brand",
    },
    {
      key: "prodcode",
      label: "Product Code",
    },

    {
      key: "proddesc",
      label: "Product Desc",
    },
    {
      key: "rci",
      label: rcicolumn,
    },
    { key: "median", label: "Median" },
    { key: "maxx", label: "Max" },
    {
      key: "m1_unadjusted_budget_unit",
      label: `Unadj.Budget UN(${Month1})`,
    },
    {
      key: "m1_unadjusted_budget_value",
      label: `Unadj.Budget Val(${Month1})(L)`,
    },
    {
      key: "m1_plus_minus",
      label: "M1 Inc/Dec",
    },
    {
      key: "new_defaultvalue1",
      label: String(Month1) + " Growth Summary Val",
    },
    {
      key: "m1_adjusted_budget_unit",
      label: `Adj.Bud.UN(${Month1})`,
    },
    {
      key: "m1_adjusted_budget_value",
      label: `Adj.Bud.Value(${Month1})(L)`,
    },
    {
      key: "post_budget_adjustment_m1_rci",
      label: `Adj RCI UN(${Month1})`,
    },
    {
      key: "m2_unadjusted_budget_unit",
      label: `Unadj.Budget UN(${Month2})`,
    },
    {
      key: "m2_unadjusted_budget_value",
      label: `Unadj.Budget VAL(${Month2})(L)`,
    },
    {
      key: "m2_plus_minus",
      label: "M2 Inc/Dec",
    },
    {
      key: "new_defaultvalue2",
      label: String(Month2) + " Growth Summary Val",
    },
    {
      key: "m2_adjusted_budget_unit",
      label: `Adj.Bud.UN(${Month2})`,
    },
    {
      key: "m2_adjusted_budget_value",
      label: `Adj.Bud.Val(${Month2})(L)`,
    },
    {
      key: "post_budget_adjustment_m2_rci",
      label: `Adj RCI UN(${Month2})(L)`,
    },
    {
      key: "m3_unadjusted_budget_unit",
      label: `Unadj.Budget UN(${Month3})(L)`,
    },
    {
      key: "m3_unadjusted_budget_value",
      label: `Unadj.Budget Val(${Month3})(L)`,
    },
    {
      key: "m3_plus_minus",
      label: "M3 Inc/Dec",
    },
    {
      key: "new_defaultvalue3",
      label: String(Month3) + " Growth Summary Val",
    },
    {
      key: "m3_adjusted_budget_unit",
      label: `Adj.Bud.UN(${Month3})`,
    },
    {
      key: "m3_adjusted_budget_value",
      label: `Adj.Bud.Val(${Month3})`,
    },
    {
      key: "post_budget_adjustment_m3_rci",
      label: `Adj RCI UN(${Month3})`,
    },
    { key: "rci_guardrail_check_m1", label: `Response(${Month1})` },
    {
      key: "rci_guardrail_check_m2",
      label: `Response(${Month2})`,
    },
    {
      key: "rci_guardrail_check_m3",
      label: `Response(${Month3})`,
    },
    {
      key: "growthvalue_in_lakh1",
      label: String(Month1) + " " + csv_year,
    },
    {
      key: "growthvalue_in_lakh2",
      label: String(Month2) + " " + csv_year,
    },
    {
      key: "growthvalue_in_lakh3",
      label: String(Month3) + " " + csv_year,
    },
    {
      key: "reason",
      label: "Reason*",
    },
    {
      key: "comment",
      label: "Additional Comments",
    },
  ];
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 40,
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
      },
      {
        accessorKey: "rbmcode",
        header: "RBM Code",
        size: 130,
        Cell: (cell) => {
          return (
            <p
              title={cell.cell.row.original.rbmcode}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {cell.cell.row.original.rbmcode}
            </p>
          );
        },
      },
      {
        accessorKey: "rbmname",
        header: "RBM Name",
        size: 130,
        Cell: (cell) => {
          return (
            <p
              title={cell.cell.row.original.rbmname}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {cell.cell.row.original.rbmname}
            </p>
          );
        },
      },
      {
        accessorKey: "brand",
        header: "Brand",
        size: 80,
        Cell: (cell) => {
          return (
            <p
              title={cell.cell.row.original.brand}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {cell.cell.row.original.brand}
            </p>
          );
        },
      },
      {
        accessorKey: "prodcode",
        header: "Product Code",
        size: 120,
        Cell: (cell) => {
          return (
            <p
              title={cell.cell.row.original.prodcode}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {cell.cell.row.original.prodcode}
            </p>
          );
        },
      },
      {
        accessorKey: "proddesc",
        header: "Product",
        size: 220,
        Cell: (cell) => {
          return (
            <p
              title={cell.cell.row.original.proddesc}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {cell.cell.row.original.proddesc}
            </p>
          );
        },
      },
      {
        accessorKey: "rci",
        header: rcicolumn,
        size: 80,
        Cell: (cell) => {
          const value = cell.cell.row.original.rci.toFixed(8);
          return (
            <p
              title={cell.cell.row.original.rci}
              className="ellipsis"
              style={{ margin: "0px", padding: "0px" }}
            >
              {value}
            </p>
          );
        },
      },
      { accessorKey: "median", header: "Median", size: 50 },
      { accessorKey: "maxx", header: "Max", size: 50 },
      {
        accessorKey: "m1_unadjusted_budget_unit",
        header: `Unadj.Bud U(${Month1})`,
        size: 100,
      },
      {
        accessorKey: "m1_unadjusted_budget_value",
        header: `Unadj.Bud V(${Month1})`,
        size: 100,
      },
      {
        accessorKey: "m1_plus_minus",
        header: `Inc.(${Month1})/Dec.(${Month1})`,
        size: 130,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand &&
            cell.cell.row.original.id === adjustedId 
           
          ) {
            if (
              parseInt(parseFloat(adjustedtotalBrandSum[adjustedBrand]).toFixed(8)) >
                parseInt(parseFloat(totalBrandSum[adjustedBrand]).toFixed(8)) 
            ) {
              cell.cell.row.original.m1_plus_minus = EnteredValue;
              seterrorMessage("BEYOND RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum[adjustedBrand]).toFixed(8)) <
                parseInt(parseFloat(totalBrandSum[adjustedBrand]).toFixed(8)) 
            ) {
              cell.cell.row.original.m1_plus_minus = EnteredValue;
              seterrorMessage("BELOW RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum[adjustedBrand]).toFixed(8)) ==
                parseInt(parseFloat(totalBrandSum[adjustedBrand])).toFixed(8) 
            ) {
              cell.cell.row.original.m1_plus_minus = EnteredValue;
              // addedList[cell.cell.row.original.brand][cell.cell.row.original.id] = parseFloat(
              //   unadjustedList[cell.cell.row.original.brand][cell.cell.row.original.id]

              // );
              seterrorMessage("");
            }
          }

          return (
            <div>
              <input
                id="EnteredTxt"
                type="number"
                onChange={(event) => handleID1(cell, event)}
                style={{ size: "100px", fontWeight: "bold" }}
                defaultValue={parseInt(cell.cell.row.original.m1_plus_minus)}
                disabled={disabled}
              />

              {cell.cell.row.original.prodcode === adjustedBrand ? (
                <p
                  style={{
                    fontSize: "8px",
                    paddingLeft: "5px",
                    margin: "0px",
                    color: "red",
                    padding: "0px",
                  }}
                >
                  {errorMessage}
                </p>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "new_defaultvalue1",
        header: `%Gr V(${Month1})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand &&
            cell.cell.row.original.id === adjustedId
          ) {
            cell.cell.row.original.new_defaultvalue1 = (
              (parseFloat(cell.cell.row.original.m1_adjusted_budget_value) /
                (cell.cell.row.original.new_value1 / 100000) -
                1) *
              100
            ).toFixed(0);
          }
          return (
            <p
              title={cell.cell.row.original.new_defaultvalue1}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.new_defaultvalue1}
            </p>
          );
        },
      },

      {
        accessorKey: "m1_adjusted_budget_unit",
        header: `Adj.Bud U(${Month1})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand &&
            cell.cell.row.original.id === adjustedId
          ) {
            for (let row of rows) {
              if (row["id"] === adjustedId) {
                row["m1_adjusted_budget_unit"] =
                  addedList[adjustedBrand][adjustedId];
              }
            }
          }
          return (
            <p
              title={cell.cell.row.original.m1_adjusted_budget_unit}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m1_adjusted_budget_unit}
            </p>
          );
        },
      },
      {
        accessorKey: "m1_adjusted_budget_value",
        header: `Adj.Bud V(${Month1})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand &&
            cell.cell.row.original.id === adjustedId
          ) {
            for (let row of rows) {
              if (row["id"] === adjustedId) {
                cell.cell.row.original["m1_adjusted_budget_value"] = (
                  (addedList[adjustedBrand][adjustedId] *
                    cell.cell.row.original.nsp1) /
                  100000
                ).toFixed(8);
              }
            }
          }
          return (
            <p
              title={cell.cell.row.original.m1_adjusted_budget_value}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m1_adjusted_budget_value}
            </p>
          );
        },
      },
      {
        accessorKey: "post_budget_adjustment_m1_rci",
        header: adjustedrciname1,
        size: 100,
        Cell: (cell) => {
          if (cell.cell.row.original.id === adjustedId) {
            cell.cell.row.original.post_budget_adjustment_m1_rci =
              calculatedRci;
          }
          return (
            <p
              title={cell.cell.row.original.post_budget_adjustment_m1_rci}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.post_budget_adjustment_m1_rci}
            </p>
          );
        },
      },
      {
        accessorKey: "m2_unadjusted_budget_unit",
        header: `Unadj.Bud U(${Month2})`,
        size: 100,
      },
      {
        accessorKey: "m2_unadjusted_budget_value",
        header: `Unadj.Bud V(${Month2})`,
        size: 100,
      },
      {
        accessorKey: "m2_plus_minus",
        header: `Inc.(${Month2})/Dec.(${Month2})`,
        size: 130,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand1 &&
            cell.cell.row.original.id === adjustedId1 
          ) {
            if (
              parseInt(parseFloat(adjustedtotalBrandSum1[adjustedBrand1]).toFixed(8)) >
                parseInt(parseFloat(totalBrandSum1[adjustedBrand1]).toFixed(8)) 
            ) {
              cell.cell.row.original.m2_plus_minus = EnteredValue1;
              seterrorMessage1("BEYOND RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum1[adjustedBrand1]).toFixed(8)) <
                parseInt(parseFloat(totalBrandSum1[adjustedBrand1]).toFixed(8))
            ) {
              cell.cell.row.original.m2_plus_minus = EnteredValue1;
              seterrorMessage1("BELOW RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum1[adjustedBrand1]).toFixed(8)) ==
                parseInt(parseFloat(totalBrandSum1[adjustedBrand1]).toFixed(8)) 
            ) {
              cell.cell.row.original.m2_plus_minus = EnteredValue1;

              seterrorMessage1("");
            }
          }
          return (
            <div>
              <input
                id="EnteredTxt1"
                type="number"
                onChange={(event) => handleID2(cell, event)}
                style={{ size: "100px", fontWeight: "bold" }}
                defaultValue={parseInt(cell.cell.row.original.m2_plus_minus)}
                disabled={disabled}
              />

              {cell.cell.row.original.prodcode === adjustedBrand1 ? (
                <p
                  style={{
                    fontSize: "8px",
                    paddingLeft: "5px",
                    margin: "0px",
                    color: "red",
                    padding: "0px",
                  }}
                >
                  {errorMessage1}
                </p>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "new_defaultvalue2",
        header: `%Gr V(${Month2})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand1 &&
            cell.cell.row.original.id === adjustedId1
          ) {
            cell.cell.row.original.new_defaultvalue2 = (
              (parseFloat(cell.cell.row.original.m2_adjusted_budget_value) /
                (cell.cell.row.original.new_value2 / 100000) -
                1) *
              100
            ).toFixed(0);
          }
          return (
            <p
              title={cell.cell.row.original.new_defaultvalue2}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.new_defaultvalue2}
            </p>
          );
        },
      },
      {
        accessorKey: "m2_adjusted_budget_unit",
        header: `Adj.Bud U(${Month2})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand1 &&
            cell.cell.row.original.id === adjustedId1
          ) {
            for (let row of rows) {
              if (row["id"] === adjustedId1) {
                row["m2_adjusted_budget_unit"] =
                  addedList1[adjustedBrand1][adjustedId1];
              }
            }
          }
          return (
            <p
              title={cell.cell.row.original.m2_adjusted_budget_unit}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m2_adjusted_budget_unit}
            </p>
          );
        },
      },
      {
        accessorKey: "m2_adjusted_budget_value",
        header: `Adj.Bud V(${Month2})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand1 &&
            cell.cell.row.original.id === adjustedId1
          ) {
            for (let row of rows) {
              if (row["id"] === adjustedId1) {
                cell.cell.row.original["m2_adjusted_budget_value"] = (
                  (addedList1[adjustedBrand1][adjustedId1] *
                    cell.cell.row.original.nsp2) /
                  100000
                ).toFixed(8);
              }
            }
          }
          return (
            <p
              title={cell.cell.row.original.m2_adjusted_budget_value}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m2_adjusted_budget_value}
            </p>
          );
        },
      },
      {
        accessorKey: "post_budget_adjustment_m2_rci",
        header: adjustedrciname2,
        size: 100,
        Cell: (cell) => {
          if (cell.cell.row.original.id === adjustedId1) {
            cell.cell.row.original.post_budget_adjustment_m2_rci =
              calculatedRci1;
          }
          return (
            <p
              title={cell.cell.row.original.post_budget_adjustment_m2_rci}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.post_budget_adjustment_m2_rci}
            </p>
          );
        },
      },
      {
        accessorKey: "m3_unadjusted_budget_unit",
        header: `Unadj.Bud U(${Month3})`,
        size: 100,
      },
      {
        accessorKey: "m3_unadjusted_budget_value",
        header: `Unadj.Bud V(${Month3})`,
        size: 100,
      },
      {
        accessorKey: "m3_plus_minus",
        header: `Inc.(${Month3})/Dec.(${Month3})`,
        size: 130,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand2 &&
            cell.cell.row.original.id === adjustedId2 
          ) {
            if (
              parseInt(parseFloat(adjustedtotalBrandSum2[adjustedBrand2]).toFixed(8)) >
                parseInt(parseFloat(totalBrandSum2[adjustedBrand2]).toFixed(8))
            ) {
              cell.cell.row.original.m3_plus_minus = EnteredValue2;
              seterrorMessage2("BEYOND RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum2[adjustedBrand2]).toFixed(8)) <
                parseInt(parseFloat(totalBrandSum2[adjustedBrand2]).toFixed(8)) 
            ) {
              cell.cell.row.original.m3_plus_minus = EnteredValue2;
              seterrorMessage2("BELOW RBM BUDGET");
            } else if (
              parseInt(parseFloat(adjustedtotalBrandSum2[adjustedBrand2]).toFixed(8)) ==
                parseInt(parseFloat(totalBrandSum2[adjustedBrand2]).toFixed(8))
            ) {
              cell.cell.row.original.m3_plus_minus = EnteredValue2;

              seterrorMessage2("");
            }
          }
          return (
            <div>
              <input
                id="EnteredTxt2"
                type="number"
                onChange={(event) => handleID3(cell, event)}
                style={{ size: "100px", fontWeight: "bold" }}
                defaultValue={parseInt(cell.cell.row.original.m3_plus_minus)}
                disabled={disabled}
              />

              {cell.cell.row.original.prodcode === adjustedBrand2 ? (
                <p
                  style={{
                    fontSize: "8px",
                    paddingLeft: "5px",
                    margin: "0px",
                    color: "red",
                    padding: "0px",
                  }}
                >
                  {errorMessage2}
                </p>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "new_defaultvalue3",
        header: `%Gr V(${Month3})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand2 &&
            cell.cell.row.original.id === adjustedId2
          ) {
            cell.cell.row.original.new_defaultvalue3 = (
              (parseFloat(cell.cell.row.original.m3_adjusted_budget_value) /
                (cell.cell.row.original.new_value3 / 100000) -
                1) *
              100
            ).toFixed(0);
          }
          return (
            <p
              title={cell.cell.row.original.new_defaultvalue3}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.new_defaultvalue3}
            </p>
          );
        },
      },
      {
        accessorKey: "m3_adjusted_budget_unit",
        header: `Adj.Bud U(${Month3})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand2 &&
            cell.cell.row.original.id === adjustedId2
          ) {
            for (let row of rows) {
              if (row["id"] === adjustedId2) {
                row["m3_adjusted_budget_unit"] =
                  addedList2[adjustedBrand2][adjustedId2];
              }
            }
          }
          return (
            <p
              title={cell.cell.row.original.m3_adjusted_budget_unit}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m3_adjusted_budget_unit}
            </p>
          );
        },
      },
      {
        accessorKey: "m3_adjusted_budget_value",
        header: `Adj.Bud V(${Month3})`,
        size: 100,
        Cell: (cell) => {
          if (
            cell.cell.row.original.prodcode === adjustedBrand2 &&
            cell.cell.row.original.id === adjustedId2
          )
            for (let row of rows) {
              if (row["id"] === adjustedId2) {
                cell.cell.row.original["m3_adjusted_budget_value"] = (
                  (addedList2[adjustedBrand2][adjustedId2] *
                    cell.cell.row.original.nsp3) /
                  100000
                ).toFixed(8);
              }
            }
          return (
            <p
              title={cell.cell.row.original.m3_adjusted_budget_value}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.m3_adjusted_budget_value}
            </p>
          );
        },
      },
      {
        accessorKey: "post_budget_adjustment_m3_rci",
        header: adjustedrciname3,
        size: 100,
        Cell: (cell) => {
          if (cell.cell.row.original.id === adjustedId2) {
            cell.cell.row.original.post_budget_adjustment_m3_rci =
              calculatedRci2;
          }
          return (
            <p
              title={cell.cell.row.original.post_budget_adjustment_m3_rci}
              className="ellipsis"
              style={{ margin: "0px" }}
            >
              {cell.cell.row.original.post_budget_adjustment_m3_rci}
            </p>
          );
        },
      },
      {
        accessorKey: "rci_guardrail_check_m1",
        header: `Response(${Month1})`,
        size: 120,
        Cell: (cell) => {
          var tempComments = "";
          if (cell.cell.row.original.id == adjustedId) {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              tempComments = "within guardrail";
              setcomments("within guardrail");
              setcommentsColor("green");
              // cell.cell.row.original.rci_guardrail_check_m1 = "within guardrail"
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments("below guardrail");
              tempComments = "below guardrail";
              setcommentsColor("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "below guardrail"
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments("beyond guardrail");
              tempComments = "beyond guardrail";
              setcommentsColor("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "beyond guardrail"
            } else {
              setcomments("");
              tempComments = "";
            }
          } else {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m1_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m1_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments("within guardrail");
              setcommentsColor("green");
              cell.cell.row.original.rci_guardrail_check_m1 =
                "within guardrail";
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments("below guardrail");
              setcommentsColor("red");
              cell.cell.row.original.rci_guardrail_check_m1 = "below guardrail";
              // console.log(
              //   cell.cell.row.original.maxx,
              //   cell.cell.row.original.median,
              //   cell.cell.row.original.post_budget_adjustment_m1_rci,
              //   "++++++++++++++ELSE IF"
              // );
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m1_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments("beyond guardrail");
              setcommentsColor("red");
              cell.cell.row.original.rci_guardrail_check_m1 =
                "beyond guardrail";
            } else {
              setcomments("");
            }
          }
          return (
            <div>
              {" "}
              {cell.cell.row.original.id == adjustedId ? (
                <p
                  style={{
                    color: tempComments == "within guardrail" ? "green" : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {tempComments}
                </p>
              ) : (
                <p
                  style={{
                    color:
                      cell.cell.row.original.rci_guardrail_check_m1 ==
                      "within guardrail"
                        ? "green"
                        : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {cell.cell.row.original.rci_guardrail_check_m1}
                </p>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "rci_guardrail_check_m2",
        header: `Response(${Month2})`,
        size: 120,
        Cell: (cell) => {
          var tempComments1 = "";
          if (cell.cell.row.original.id == adjustedId1) {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              tempComments1 = "within guardrail";
              setcomments1("within guardrail");
              setcommentsColor1("green");
              // cell.cell.row.original.rci_guardrail_check_m1 = "within guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments1("below guardrail");
              tempComments1 = "below guardrail";
              setcommentsColor1("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "below guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m2_rci,"++++++++++++++ELSE IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments1("beyond guardrail");
              tempComments1 = "beyond guardrail";
              setcommentsColor1("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "beyond guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
            } else {
              setcomments1("");
              tempComments1 = "";
            }
          } else {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m2_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m2_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments1("within guardrail");
              setcommentsColor1("green");
              cell.cell.row.original.rci_guardrail_check_m2 =
                "within guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments1("below guardrail");
              setcommentsColor1("red");
              cell.cell.row.original.rci_guardrail_check_m2 = "below guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ELSE IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m2_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments1("beyond guardrail");
              setcommentsColor1("red");
              cell.cell.row.original.rci_guardrail_check_m2 =
                "beyond guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
            } else {
              setcomments1("");
            }
          }
          return (
            <div>
              {" "}
              {cell.cell.row.original.id == adjustedId1 ? (
                <p
                  style={{
                    color:
                      tempComments1 == "within guardrail" ? "green" : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {tempComments1}
                </p>
              ) : (
                <p
                  style={{
                    color:
                      cell.cell.row.original.rci_guardrail_check_m2 ==
                      "within guardrail"
                        ? "green"
                        : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {cell.cell.row.original.rci_guardrail_check_m2}
                </p>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "rci_guardrail_check_m3",
        header: `Response(${Month3})`,
        size: 150,
        Cell: (cell) => {
          var tempComments2 = "";
          if (cell.cell.row.original.id == adjustedId2) {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              tempComments2 = "within guardrail";
              setcomments2("within guardrail");
              setcommentsColor2("green");
              // cell.cell.row.original.rci_guardrail_check_m3 = "within guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m3_rci,"++++++++++++++IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments2("below guardrail");
              tempComments2 = "below guardrail";
              setcommentsColor2("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "below guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m3_rci,"++++++++++++++ELSE IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments2("beyond guardrail");
              tempComments2 = "beyond guardrail";
              setcommentsColor2("red");
              // cell.cell.row.original.rci_guardrail_check_m1 = "beyond guardrail"
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
            } else {
              setcomments2("");
              tempComments2 = "";
            }
          } else {
            if (
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.median),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.median)
              ) ||
              between(
                parseFloat(
                  cell.cell.row.original.post_budget_adjustment_m3_rci
                ),
                parseFloat(cell.cell.row.original.rci),
                parseFloat(cell.cell.row.original.maxx)
              ) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.rci) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.median) ||
              parseFloat(
                cell.cell.row.original.post_budget_adjustment_m3_rci
              ) == parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments2("within guardrail");
              setcommentsColor2("green");
              cell.cell.row.original.rci_guardrail_check_m3 =
                "within guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) <
              parseFloat(cell.cell.row.original.rci)
            ) {
              setcomments2("below guardrail");
              setcommentsColor2("red");
              cell.cell.row.original.rci_guardrail_check_m3 = "below guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ELSE IF")
            } else if (
              parseFloat(cell.cell.row.original.post_budget_adjustment_m3_rci) >
              parseFloat(cell.cell.row.original.maxx)
            ) {
              setcomments2("beyond guardrail");
              setcommentsColor2("red");
              cell.cell.row.original.rci_guardrail_check_m3 =
                "beyond guardrail";
              // console.log(cell.cell.row.original.maxx,cell.cell.row.original.median,cell.cell.row.original.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
            } else {
              setcomments2("");
            }
          }
          return (
            <div>
              {" "}
              {cell.cell.row.original.id == adjustedId2 ? (
                <p
                  style={{
                    color:
                      tempComments2 == "within guardrail" ? "green" : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {tempComments2}
                </p>
              ) : (
                <p
                  style={{
                    color:
                      cell.cell.row.original.rci_guardrail_check_m3 ==
                      "within guardrail"
                        ? "green"
                        : "red",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {cell.cell.row.original.rci_guardrail_check_m3}
                </p>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "reason",
        header: "Reason*",
        size: 150,
        Cell: (cell) => {
          return (
            <select
              key={cell.cell.row.original.id}
              className="filter-style1"
              id="rbm"
              style={{
                marginRight: "5px",
                size: "200px",
                margin: "0px",
                padding: "0px",
              }}
              onChange={(event) => handleSelectReason(cell, event)}
              value={cell.cell.row.original.reason}
            >
              <option>Select Reason*</option>
              {resonsComponent}
            </select>
          );
        },
      },
      {
        accessorKey: "comment",
        header: "Additional Comments",
        size: 150,
        Cell: (cell) => {
          return (
            <textarea
              name=""
              id=""
              cols="30"
              rows="2"
              style={{
                border: "none",
                backgroundColor: "#E5E5E5",
                borderRadius: "5px",
                paddingLeft: "5px",
                paddingTop: "2px",
              }}
              defaultValue={cell.cell.row.original.comment}
              onChange={(e) => handleComment(cell, e)}
            >
              {/* {cell.cell.row.original.comment} */}
            </textarea>
          );
        },
      },
    ],
    [handleID1, handleID2, handleID3, rows]
  );
  let BransListComponent = [];
  BrandsListData.forEach((item, index) => {
    BransListComponent.push(<option key={index}>{item}</option>);
  });

  const handleChangeBrand = (event) => {
    for (let item of filtersData) {
      setselectedBrand(event.target.value);
      let flag = true;
      if (item["brandname"] == event.target.value) {
        if (event.target.value == "All") {
          setproductsListData(item["productname"]);
        } else {
          setproductsListData(["All", ...item["productname"]]);
        }
        if (flag) {
          setselectedProduct("All");
          flag = false;
        }
      }
    }

    //  setproductsListData(filtersData[event.target.value])
  };

  let productComponent = [];
  productsListData.forEach((item, index) => {
    productComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  // const handleChangeProduct = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setselectedProduct(typeof value === "string" ? value.split(",") : value);
  // };

  // const handleChangeMultiple = (event) => {
  //   const { options } = event.target;
  //   const value = [];
  //   for (let i = 0, l = options.length; i < l; i += 1) {
  //     if (options[i].selected) {
  //       value.push(options[i].value);
  //     }
  //   }
  //   setselectedProduct(value);
  // };
  const handleChangeProduct = (event) => {
    const temp = event.target.value;
    setselectedProduct(temp);
  };

  const handleDownload = (event) => {
    axiosRequest({
      url: "bu_head_app/downloadfilterabmdata",
      method: "GET",
      headers: api_headers,
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      // let temp_file_name = table + ".csv";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BUH Data.csv");
      document.body.appendChild(link);
      link.click();
      // handleSnackBar("downloaded successfully","success");
    });
  };
  const [reasonsList, setreasonsList] = useState([]);
  var formData = new FormData();
  const changeHandler = (event) => {
    // console.log("FILE CHANGED");
    let img = event.target.files[0];
    // var filename="ptl.csv";

    // console.log(event.target.files[0].name, "FORM DATAA");
    setFile(img);
    setIsFilePicked(true);

    setselectedFileName(event.target.files[0].name);
  };
  //APi to get Reasons dropdown  data
  const getReasonsdata = async () => {
    await axiosRequest({
      url: "bu_head_app/getreasons/",
      method: "GET",
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setreasonsList(data?.data?.data);
      } else {
      }
    });
  };
  let resonsComponent = [];
  reasonsList.forEach((item, index) => {
    resonsComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });

  const [disabled, setdisabled] = useState(false);

  return (
    <div style={{ height: 400, width: "100%" }} className="rbm-table">
      <div style={{}}>
        <Modal
          open={showModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <CloseIcon
              onClick={handleCloseModal}
              style={{
                marginLeft: "370px",
                color: "grey",
                alignSelf: "flex-end",
              }}
            />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Before Submitting, Please save the respective Brand and Products
              that you have adjusted .
            </Typography>
            <div
              style={{
                marginTop: "10px",
                marginLeft: "290px",
                alignSelf: "flex-end",
              }}
            >
              <button className="save-btn " onClick={handleSave}>
                {loaderSave === true ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress
                      size="1rem"
                      color="inherit"
                      display={loaderSave}
                    />
                  </div>
                ) : (
                  <span>Save as Draft</span>
                )}
              </button>
              <button
                onClick={handleCloseModal}
                style={{ marginLeft: "10px" }}
                className="submit-btn"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={showStatusModal}
          onClose={handleCloseStatusModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <CloseIcon
              onClick={handleCloseStatusModal}
              style={{
                marginLeft: "370px",
                color: "grey",
                alignSelf: "flex-end",
              }}
            />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Before Submitting, Please Save all the Brands and respected
              Products Data .
            </Typography>
            <div
              style={{
                marginTop: "10px",
                marginLeft: "290px",
                alignSelf: "flex-end",
              }}
            >
              {/* <button className="save-btn" onClick={handleSave}>
                {loaderSave === true ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress
                      size="1rem"
                      color="inherit"
                      display={loaderSave}
                    />
                  </div>
                ) : (
                  <span>Save as Draft</span>
                )}
              </button> */}
              <button
                onClick={handleCloseStatusModal}
                style={{ marginLeft: "10px" }}
                className="submit-btn"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontWeight: "500",
        }}
      >
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "5px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              RBM Name
            </label>
            
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
            >
              <option value="volvo">ALL</option>
            </select>
          </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>

            <select
              className="filter-style1"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
            >
              {loaderFilter === true ? (
                <option value="">Loading...</option>
              ) : (
                <option value="">select brand name</option>
              )}
              {BransListComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Product
            </label>
            {/* <FormControl sx={{ m: 1, width: 300 }}>
              {" "}
              <InputLabel id="demo-multiple-name-label">Name</InputLabel>{" "}
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                value={selectedProduct}
                onChange={handleChangeMultiple}
                input={<OutlinedInput label="Name" />}
                // MenuProps={MenuProps}
              >
                {" "}style
                {productsListData.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    // style={getStyles(name, personName, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>{" "} */}
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={handleChangeProduct}
              value={selectedProduct}
            >
              <option value="volvo">select product</option>
              {productComponent}
            </select>
          </div>
          <button
            onClick={handleApply}
            className="submit-btn"
            style={{ marginTop: "20px" }}
          >
            Apply
          </button>
        </div>
        <div style={{ display: "flex" }}>
          <button className="save-btn" onClick={handleSave} disabled={disabled}>
            {loaderSave === true ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  size="1rem"
                  color="inherit"
                  display={loaderSave}
                />
              </div>
            ) : (
              <span>Save as Draft</span>
            )}
          </button>

          <button
            className="submit-btn"
            style={{ marginRight: "10px", marginLeft: "10px" }}
            onClick={handleSubmit}
            disabled={disabled}
          >
            {loaderSubmit === true ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  size="1rem"
                  color="inherit"
                  display={loaderSubmit}
                />
              </div>
            ) : (
              <span>Submit</span>
            )}
          </button>
          <Button
            style={{
              backgroundColor: "#e5e5e5",
              color: "black",
              height: "26px",
              width: "150px",              // ✅ Fixed width
              minWidth: "150px",           // ✅ Prevent shrink
              textTransform: "none",
              fontSize: "13px",
              marginRight: "8px",
              whiteSpace: "nowrap",        // ✅ Prevent wrapping
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            variant="contained"
            component="label"
          >
            <AttachmentIcon
              size="small"
              style={{ marginRight: "5px" }}
            />
            {isFilePicked ? selectedFileName : "Select File"}
            <input
              onChange={changeHandler}
              onClick={(event) => {
                event.target.value = null;
              }}
              hidden
              accept="/*"
              type="file"
            />
          </Button>

          <LoadingButton
            onClick={handleFileUpload}
            loading={loaderUpload}
            variant="contained"
            style={{
              height: "26px",
              width: "130px",              // ✅ Fixed width
              minWidth: "130px",
              marginRight: "8px",
              backgroundColor: "#e5e5e5",
              textTransform: "none",
              color: "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <FileUploadIcon
              style={{ display: loaderUpload ? "none" : "" }}
              fontSize="small"
            />
            {loaderUpload ? "" : "Upload File"}
          </LoadingButton>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            // onClick={handleDownload}
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
            <CSVLink
              headers={colums_rbm}
              data={rows}
              filename={"BUH Data.csv"}
              style={{ textDecoration: "none", color: "black" }}
            >
              Download
            </CSVLink>
          </button>
        </div>
      </div>
      {loader == true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
            marginBottom: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader} />
        </div>
      ) : rows.length ? (
        <div>
          <MaterialReactTable
            displayColumnDefOptions={{
              "mrt-row-actions": {
                muiTableHeadCellProps: {
                  align: "center",
                },
                size: 120,
              },
            }}

            muiTableBodyCellProps={{

              sx: {

                fontSize: '11px',

                padding:'4px 0px 0px 4px',

                margin:'0px'

              },

            }}
            columns={columns}
            data={rows}
            className="rbmtable"
            enableColumnOrdering
            enablePinning
            initialState={{
              pagination: { pageSize: 15 },
              columnVisibility: {
                id: false,
                rbmcode: false,
                prodcode: false,
              },
              columnPinning: { left: ["id", "rbmcode"] },
              density: "compact",
            }}
            enableStickyHeader
            muiTableContainerProps={{ sx: { maxHeight: "500px" } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [15, 25, 50, 75, 100],
            }}
          />
          {loader === false ? (
            <div
              style={{
                height: "135px",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <table className="table-buh">
                <tr className="table-tr-td-buh">
                  <th className="table-tr-td-buh"></th>
                  {/* <th className="table-tr-td-buh">UnAdj Bug U({Month1}) </th>
                  <th className="table-tr-td-buh">Adj Bug U({Month1}) </th> */}

                  <th className="table-tr-td-buh">UnAdj Bug V({Month1}) </th>
                  <th className="table-tr-td-buh">Adj Bug V({Month1}) </th>

                  <th className="table-tr-td-buh">% Growth Adj V({Month1}) </th>
                  {/* <th className="table-tr-td-buh">% Growth V({Month1}) </th>
        
                  <th className="table-tr-td-buh">UnAdj Bug U({Month2}) </th>
                  <th className="table-tr-td-buh">Adj Bug U({Month2}) </th> */}

                  <th className="table-tr-td-buh">UnAdj Bug V({Month2}) </th>
                  <th className="table-tr-td-buh">Adj Bug V({Month2}) </th>

                  <th className="table-tr-td-buh">% Growth Adj V({Month2}) </th>
                  {/* <th className="table-tr-td-buh">% Growth V({Month2}) </th> */}

                  {/* <th className="table-tr-td-buh">UnAdj Bug U({Month3}) </th>
                  <th className="table-tr-td-buh">Adj Bug U({Month3}) </th> */}

                  <th className="table-tr-td-buh">UnAdj Bug V({Month3}) </th>
                  <th className="table-tr-td-buh">Adj Bug V({Month3}) </th>

                  <th className="table-tr-td-buh">% Growth Adj V({Month3}) </th>
                  {/* <th className="table-tr-td-buh">% Growth V({Month3}) </th> */}
                </tr>
                <tr className="table-tr-td-buh">
                  <td className="table-tr-td-buh">Total</td>
                  {/* <td className="table-tr-td-buh">{filtersDataSum['unadj_tot_un']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_un']}</td> */}

      <td className="table-tr-td-buh">{filtersDataSum['unadj_tot']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot']}</td>
      
      <td className="table-tr-td-buh">{filtersDataSum['gr_tot']}</td>
      {/* <td className="table-tr-td-buh">{filtersDataSum['gr_tot_unadj']}</td> */}

                  {/* <td className="table-tr-td-buh">
                    {filtersDataSum["unadj1_tot_un"]}
                  </td>
                  <td className="table-tr-td-buh">
                    {filtersDataSum["adj1_tot_un"]}
                  </td> */}

                  <td className="table-tr-td-buh">
                    {filtersDataSum["unadj1_tot"]}
                  </td>
                  <td className="table-tr-td-buh">
                    {filtersDataSum["adj1_tot"]}
                  </td>

                  <td className="table-tr-td-buh">
                    {filtersDataSum["gr_tot1"]}
                  </td>
                  {/* <td className="table-tr-td-buh">
                    {filtersDataSum["gr_tot_unadj1"]}
                  </td>

                  <td className="table-tr-td-buh">
                    {filtersDataSum["unadj2_tot_un"]}
                  </td>
                  <td className="table-tr-td-buh">
                    {filtersDataSum["adj2_tot_un"]}
                  </td> */}

                  <td className="table-tr-td-buh">
                    {filtersDataSum["unadj2_tot"]}
                  </td>
                  <td className="table-tr-td-buh">
                    {filtersDataSum["adj2_tot"]}
                  </td>

                  <td className="table-tr-td-buh">
                    {filtersDataSum["gr_tot2"]}
                  </td>
                  {/* <td className="table-tr-td-buh">
                    {filtersDataSum["gr_tot_unadj2"]}
                  </td> */}
                </tr>
              </table>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <p
          style={{
            textAlign: "center",
            marginTop: "150px",
            marginBottom: "150px",
          }}
        >
          Please Select the above filters to see the Data...
        </p>
      )}

      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
    </div>
  );
}
